// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comparison-conatiner[data-v-b6d5ca76]{background-color:var(--v-ui-lighten4)}.theme--dark.comparison-conatiner[data-v-b6d5ca76]{background-color:var(--v-ui-darken3)}", ""]);
// Exports
module.exports = exports;
